import { gql } from '@apollo/client';

export const GET_STUDENTS_IN_CLASSROOM = gql`
  query SkWeb_Classroom_5($classroomId: ID!) {
    classroom(classroomId: $classroomId) {
      id
      students {
        id
        name
        username
      }
    }
  }
`;
